import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";
import {SetAttributeLocalizationCommand} from "./setAttributeLocalization.command";
import {mintNamespacedUid} from "../utils/uid.utils";

export class AddRewardMetadata extends CommandBase {
    id: string;

    constructor(attribute: string) {
        super();
        this.id = attribute;
    }

    execute(state: RemoteConstantsModel): boolean {
        if (this.id === '') {
            return false;
        }

        if (state.rewards === undefined) {
            state.rewards = [];
        }

        const uid = mintNamespacedUid('reward', this.id, state.rewards.map(r => r.uid));
        new SetAttributeLocalizationCommand(uid, this.id, true).execute(state);

        state.rewards.push({
            uid: uid,
            id: this.id,
            active: true,
            values: {},
            entities: {}
        });
        return true;
    }
}
